import ContentLoader from 'react-content-loader'
import React from 'react'

const SwitchPlaceholder = React.memo(props => (
  <ContentLoader
    speed={2}
    width={95}
    height={35}
    viewBox="0 0 95 35"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="0" y="0" rx="17" ry="17" width="95" height="35" />
  </ContentLoader>
))

export default SwitchPlaceholder
